// extracted by mini-css-extract-plugin
export default {"root":"IM8hnxE3oF","root_hasImage":"_WgLGAe1In","root_appColor":"nlyCyaADN_","hover":"z4Ea0HLD8C","preview":"z9Lzs0hNnE","text":"iMqpEsVrEv"};